import { Link } from "react-router-dom";
import { allCategories, allSubtitles } from "@/utils/subtitles";

const accentStyles: Record<string, string> = {
  primary: "bg-primary-100 text-primary-600",
  accent: "bg-accent-100 text-accent-700",
  secondary: "bg-secondary-100 text-secondary-700",
};

export default function CategoryQuickLinks() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-14">
      <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
        <div className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-primary-600">
            <i className="ri-apps-2-line text-xl"></i>
          </span>
          <div>
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              字幕分类快捷入口
            </h2>
            <p className="mt-1 text-sm text-foreground-500">
              按类型快速筛选高清中文字幕资源
            </p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {allCategories.map((cat) => {
          const count = allSubtitles.filter((item) => item.typeSlug === cat.slug).length;
          return (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300 hover:bg-background-50"
            >
              <span
                className={`flex h-12 w-12 items-center justify-center rounded-md ${
                  accentStyles[cat.accent] ?? accentStyles.primary
                }`}
              >
                <i className={`${cat.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">
                {cat.name}
              </h3>
              <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-500">
                {cat.desc}
              </p>
              <div className="mt-4 flex items-center justify-between">
                <span className="text-xs font-medium text-secondary-700">{count} 个资源</span>
                <span className="flex items-center gap-1 text-sm font-medium text-primary-600">
                  进入分类
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"></i>
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}